import React, { ReactNode } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { IconButton } from "@fluentui/react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/hooks";
import { navigateBack } from "../../redux/feature/general/navigation-slice";
import { DOCUMENTS_LISTS } from "../../utils/constants/navigation";
import {
  selectIsAuthenticated,
  selectUserDocumentCheckout,
  tenantConfigurationState,
} from "../../redux/feature/settings/configurations-slice";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { UserDocumentCheckout } from "../../api/models/user-document-checkout";

export interface HeaderPanelProps {
  children: ReactNode;
  borderColor?: string;
  enableBackArrow?: boolean;
  onBackArrowClick?: () => void;
  applyPadding?: boolean;
  headerRowJustifyContent?: string;
}

const classNames = mergeStyleSets({
  tenantHeader: {
    width: "100%",
    backgroundColor: "var(--color-lightblue)",
    paddingLeft: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "var(--color-blue)",
  },
  headerPanelRow: {
    padding: "0.5rem 0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  backButton: {
    cursor: "pointer",
    margin: 0,
    padding: 0,
    height: "16px",
    selectors: {
      ":hover": {
        background: "none",
        color: "var(--color-black)",
      },
    },
  },
});

function HeaderPanel({
  children,
  borderColor,
  enableBackArrow,
  onBackArrowClick,
  applyPadding,
  headerRowJustifyContent,
}: Readonly<HeaderPanelProps>) {
  const dispatch = useAppDispatch();
  const configurationState = useAppSelector(tenantConfigurationState);
  const userDocumentCheckouts: UserDocumentCheckout[] = useAppSelector(selectUserDocumentCheckout);
  const isDocumentCheckout: boolean = userDocumentCheckouts?.length > 0;
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  function back() {
    dispatch(navigateBack(DOCUMENTS_LISTS));
  }

  let headerPanelRowStyle = {};
  if (headerRowJustifyContent) {
    headerPanelRowStyle = { justifyContent: headerRowJustifyContent, alignItems: "center" };
  }

  return (
    <div>
      <div className={classNames.tenantHeader}>{configurationState.selected}</div>
      {isAuthenticated && isDocumentCheckout && (
        <div
          style={{
            backgroundColor: "#ea8f00",
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "4px",
          }}
        >
          <div className={"ms-warning"} style={{ marginLeft: "10px" }}></div>
          <div style={{ color: "#474747", paddingLeft: "10px" }}>{formatMessage("cof.base.disable.data.edit")}</div>
        </div>
      )}
      <div className="headerTitle" style={{ padding: applyPadding ? "0 0.5rem 0 0.5rem" : "" }}>
        <div className={classNames.headerPanelRow} style={headerPanelRowStyle}>
          {enableBackArrow && (
            <IconButton
              id={"header_back_button"}
              iconProps={{ iconName: "ChevronLeft" }}
              ariaLabel="Go Back"
              className={classNames.backButton}
              onClick={() => {
                if (onBackArrowClick) onBackArrowClick();
                else back();
              }}
            />
          )}
          {children}
        </div>
        <div
          style={{
            borderBottom: `0.15rem solid ${borderColor ?? "var(--color-green)"}`,
            width: "100%",
            height: "3px",
            borderRadius: "25px",
          }}
        />
      </div>
    </div>
  );
}

export default HeaderPanel;
